// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3xIHC","notes":"Notes_notes__3MnZb"};